import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://riscocostruzioni.it";
const SITE_NAME = "Ri.Sco. s.r.l.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Universal SEO component — sets title, description, canonical, Open Graph
 * and Twitter tags. Use inside every route/page.
 *
 * @param {string} title       — full title tag (should already include brand)
 * @param {string} description — meta description (~155 chars)
 * @param {string} path        — canonical pathname, e.g. "/ristrutturazioni"
 * @param {string} [image]     — absolute OG image URL (defaults to site OG)
 * @param {boolean} [noindex]  — set true for admin/private pages
 */
export default function SEO({ title, description, path = "/", image, noindex = false }) {
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  return (
    <Helmet>
      <html lang="it" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
